<template>
  <div class="approve-request">
    <div class="approve-request-header">
      <div class="approve-request-close">
        <div class="button-text">Fechar</div>
        <button @click="approveClose"><div class="icon-close"></div></button>
      </div>
      <h2>Aprovar pedido</h2>
    </div>
    <hr>
    <div class="approve-request-body">
      <label for="reason">
        Observação
      </label>
      <textarea name="reason" placeholder="Escreva uma observação..."></textarea>
      <span>
        <span></span>
        <button @click="approve('BoletoFlex FIDC')" :disabled="loading">
          <div class="spinner-border spinner-border-sm" role="status" v-if="loading">
            <span class="sr-only">Loading...</span>
          </div>
          Confirmar
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import { extractFirstName } from '../../../utils/extractFirstName'

export default {
  data () {
    return {
      comment: null,
      message: null,
      loading: false,
      approveInCooldown: false
    }
  },
  methods: {
    extractFirstName,
    approveClose () {
      this.$emit('emitApproveClose')
    },
    approve (fdic) {
      console.log('UUUID ' + this.$route.params.txid)
      this.loading = true

      if (!this.approveInCooldown) {
        this.approveInCooldown = true
        this.$http.post('api/order-validation/' + this.$route.params.txid + '/approve-customer', {fdic: fdic, comment: this.comment})
          .then(function (res) {
            this.approveInCooldown = false
            this.message = res.data.msg
            console.log('OK ')
            // this.approvedText = this.extractFirstName(this.orderStatus.buyer) + ', seu parcelamento para o pedido *' + this.orderStatus.reference + '* na *' + this.orderStatus.sellerFriendlyName + '* foi aprovado! A loja já está liberada para seguir com a entrega e você deve receber um e-mail da *' + this.orderStatus.sellerFriendlyName + '* com a confirmação. Nos informe qualquer mudança no status do seu pedido.%0A%0AAqui está o link com todos os seus boletos para pagamento, onde você pode ver o status e vencimento de cada um. Enviamos também para seu e-mail uma cópia do contrato de parcelamento. Qualquer dúvida pode nos chamar =).%0A%0A'
            // this.sendWhatsappMessage(this.customerPhoneNumber, this.approvedText + ' https://meu.boletoflex.com/#/' + this.$route.params.txid)
            this.loading = false
            if (res.data['isManualApproval']) {
              this.$bvToast.toast(res.data.msg, {
                autoHideDelay: 5000,
                variant: 'success'
              })
            } else {
              this.$bvToast.toast('Pedido aprovado com sucesso', {
                autoHideDelay: 5000,
                variant: 'success'
              })
            }
            this.$root.$emit('updateWhatsappMessages')

            this.$emit('emit-approve-done', true)
            this.approveClose()
          })
          .catch(function (res) {
            console.log('Error')
            console.log(res)
            this.loading = false
            this.$bvToast.toast('Erro ao aprovar pedido: ' + res.body.toString(), {
              autoHideDelay: 5000,
              variant: 'danger'
            })
          })
      }
    },
    sendWhatsappMessage (phone, msg) {
      this.$http.get('api/transactions/' + this.$route.params.txid)
        .then(function (res) {
          this.$http.post('api/chat', {message: msg, phone: phone.toString(), transaction: null, username: this.$auth.user().username})
            .then(function (res) {
              this.$bvToast.toast('Mensagem aprovada com sucesso', {
                autoHideDelay: 5000,
                variant: 'success'
              })
              this.$root.$emit('updateWhatsappMessages')
            })
            .catch(function (res) {
              this.$bvToast.toast('Erro ao enviar mensagem', {
                autoHideDelay: 5000,
                variant: 'danger'
              })
              console.log('Error')
              console.log(res)
            })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  },
  props: ['orderStatus', 'customerPhoneNumber']
}
</script>

<style lang="scss" scoped>
.approve-request {
  width: calc(30% - 20px);
  border-radius: 16px;
  margin-left: 20px;
  float: right;
  background-color: #FFFFFF;
  .approve-request-header {
    padding: 16px;
    .approve-request-close {
      display: flex;
      justify-content: flex-end;
      button {
        width: 24px;
        height: 24px;
        float: right;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-top: -4px;
        padding: 0px;
        border: none;
        background: rgba(66, 133, 244, 0.2);
        color: #4285F4;
        outline: none;
      }
      .button-text {
        float: right;
        line-height: 1.4em;
        color: rgba(66, 133, 244, 0.75);
        margin-right: 4px;
      }
    }
  }
  h2 {
    margin: 0;
    font-size: 16px;
    color: #666666;
    &.space {
      margin-bottom: 32px;
    }
  }
  .approve-request-body {
    padding: 24px;
    label {
      font-size: 12px;
      color: #666666;
      display: flex;
      align-items: center;
      float: left;
    }
    textarea {
      width: 100%;
      min-height: 128px;
      margin-bottom: 16px;
      padding: 16px;
      border: none;
      background-color: #F3F3F3;
    }
    select {
      width: 100%;
      height: 40px;
      border: none;
      margin-bottom: 36px;
      background-color: #f3f3f3;
    }
    span {
      display: flex;
      align-items: center;
      justify-content: space-between;
      label {
        margin: 0;
      }
      button {
        width: 100px;
        height: 32px;
        border-radius: 5px;
        border: none;
        float: right;
        background-color: #1c56e0;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/ApproveRequest.vue